import React, { useState } from "react";
import { Mail, X, Loader, CheckCircle, MessageCircle } from 'lucide-react';

const ButtonContact = () => {
    const [showContactForm, setShowContactForm] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitSuccess, setSubmitSuccess] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        message: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        
        try {
            // Aquí iría la lógica de envío al backend
            // const response = await fetch('tu-endpoint', {
            //     method: 'POST',
            //     headers: {
            //         'Content-Type': 'application/json',
            //     },
            //     body: JSON.stringify(formData)
            // });
            
            // Simulamos un delay para demostración
            await new Promise(resolve => setTimeout(resolve, 1000));
            
            setSubmitSuccess(true);
            setTimeout(() => {
                setShowContactForm(false);
                setSubmitSuccess(false);
                setFormData({
                    name: '',
                    email: '',
                    phone: '',
                    message: ''
                });
            }, 2000);

        } catch (error) {
            console.error('Error submitting form:', error);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <>
            <div className="fixed bottom-8 right-8 z-10">
                <button
                    onClick={() => setShowContactForm(true)}
                    className="bg-blue-500 text-white px-6 py-3 rounded-full shadow-lg hover:bg-blue-600 transition-colors duration-300 flex items-center gap-2"
                >
                    <Mail className="h-5 w-5" />
                    Contact Us
                </button>
            </div>

            {showContactForm && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-0 z-50 w-[100vw]">
                    <div className="bg-white rounded-lg p-6 max-w-md w-[95%] h-[80vh] relative overflow-y-auto">
                        <button
                            onClick={() => setShowContactForm(false)}
                            className="absolute right-4 top-4 text-gray-500 hover:text-gray-700"
                        >
                            <X className="h-5 w-5" />
                        </button>

                        <h3 className="text-2xl font-bold mb-6">Contact Us</h3>
                        <p className="text-sm text-gray-500 mb-4">
                            If you prefer, you can also reach us by email or phone, or contact us directly via WhatsApp.
                        </p>

                        <div className="mb-4">
                            <p className="text-sm text-gray-600">Email: <strong>info@businesssolutiondubai.com</strong></p>
                            <p className="text-sm text-gray-600">Phone: <strong>+971 052 788 9164</strong></p>
                        </div>

                        <div className="mb-6">
                            <a 
                                href="https://wa.link/txunpz"
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="bg-green-500 text-white px-6 py-3 rounded-full shadow-lg hover:bg-green-600 transition-colors duration-300 flex items-center gap-2"
                            >
                                <MessageCircle className="h-5 w-5" />
                                Contact Us on WhatsApp
                            </a>
                        </div>

                        <form onSubmit={handleSubmit} className="space-y-4">
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Full Name *
                                </label>
                                <input
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                    className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    placeholder="Enter your full name"
                                />
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Email *
                                </label>
                                <input
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                    className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    placeholder="Enter your email"
                                />
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Phone Number *
                                </label>
                                <input
                                    type="tel"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    required
                                    className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    placeholder="Enter your phone number"
                                />
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Message *
                                </label>
                                <textarea
                                    name="message"
                                    value={formData.message}
                                    onChange={handleChange}
                                    required
                                    rows="4"
                                    className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    placeholder="How can we help you?"
                                ></textarea>
                            </div>

                            <button
                                type="submit"
                                disabled={isSubmitting}
                                className={`w-full py-2 px-4 rounded-lg flex items-center justify-center gap-2 ${
                                    submitSuccess
                                        ? 'bg-green-500 hover:bg-green-600'
                                        : 'bg-blue-500 hover:bg-blue-600'
                                } text-white transition-colors duration-300`}
                            >
                                {isSubmitting ? (
                                    <>
                                        <Loader className="h-5 w-5 animate-spin" />
                                        Sending...
                                    </>
                                ) : submitSuccess ? (
                                    <>
                                        <CheckCircle className="h-5 w-5" />
                                        Sent Successfully!
                                    </>
                                ) : (
                                    'Send Message'
                                )}
                            </button>
                        </form>
                    </div>
                </div>
            )}
        </>
    );
};

export default ButtonContact;
